import React from "react"
import { useSelector } from "react-redux"
import { getClockFormat } from "reduxSlices/currentSettingsSlice"
import { auditItemDetailsComponent } from "utils/auditHelper"
import { orgLocalDateTimeByClockFormat } from "utils/dateHelpers"
import { auditShape } from "utils/propTypeShapes"
import { ProfileIcon } from "shared/icons"
import ItemRow from "shared/ItemRow"
import * as FormSubmissionAuditItemDetails from "views/FormSubmission/FormSubmissionTabs/AuditTrailContent/AuditItem/AuditItemDetails"

const AuditItem = ({ audit }) => {
  const AuditItemDetailsComponent = auditItemDetailsComponent(audit, FormSubmissionAuditItemDetails)
  const clockFormat = useSelector(getClockFormat)

  return (
    <>
      <ItemRow
        itemRowHeaderContentClassName="item-row-header-content-audit-trail"
        itemRowHeaderContent={(
          <>
            <div>
              <ProfileIcon className="hidden lg:flex w-8 h-8 mr-3" user={audit.user} />
              <AuditItemDetailsComponent audit={audit} />
            </div>
            <div className="text-dark text-xs shrink-0 lg:justify-self-end">
              { orgLocalDateTimeByClockFormat(audit.createdAt, clockFormat) }
            </div>
          </>
        )}
      />
    </>
  )
}

AuditItem.propTypes = {
  audit: auditShape.isRequired,
}

export default AuditItem
